import { combineReducers } from 'redux';
import model from './model-reducers';
import viewModel from './viewmodel-reducers';

const modelReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return model(state, {
        ...action,
        device: action.device || state.activeDevice
      });
  }
};

export default combineReducers({
  model: modelReducer,
  viewModel
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/index.js